import { AppleIcon, FacebookIcon } from '../../components/ui/icons';
import type { SocialProvider } from './socialProviders';

/**
 * Brand mark for the providers we render buttons for. Google is absent by
 * design — its SDK renders a button with the logo already baked in.
 */
export function SocialProviderIcon({ provider }: { provider: Exclude<SocialProvider, 'google'> }) {
  // 18px matches the logo Google renders inside its own button.
  const props = { className: `auth-flow__social-icon auth-flow__social-icon--${provider}`, size: 18 };
  return provider === 'facebook' ? <FacebookIcon {...props} /> : <AppleIcon {...props} />;
}
